<div class="d-flex justify-content-between align-items-center mb-2">
  <div class="title">
    <strong>Shipments</strong>
  </div>
  <div class="actions">
    <button
      *ngIf="canAddShipments; else disabledButton"
      (click)="openAddShipmentModal()"
      class="btn btn-link p-0 text-capitalize"
      title="Add Shipment"
    >
      <i class="fa fa-plus"></i>
      Add Shipment
    </button>
    <ng-template #disabledButton>
        <span
          [matTooltip]="_purchaseOrder.isPending ?
          'Shipments can\'t be added until the ' + (isRCDSS ? 'Contract' : 'Purchase Order') + ' has been approved' :
          'You can\'t add shipments anymore'">
          <button [disabled]="true" class="btn btn-link p-0 text-capitalize">
            <i class="fa fa-plus"></i>
            Add Shipment
          </button>
        </span>
    </ng-template>
  </div>
</div>

<div class="shipments" *ngIf="shipments && shipments.length else noShipmentsTracking">
  <div class="shipment" *ngFor="let shipment of shipments">

    <div class="detail row" style="border-bottom: 1px solid lightgrey; padding: 10px 0;">

      <div class="col-md-9">
        <div class="tracking-code">
          <a [href]="shipment.link" target="_blank" *ngIf="!shipment.enhanced_tracking_identifier">
            {{ shipment.shipped_at | date: 'MMM d, y':'utc' }} <span
            *ngIf="shipment?.tracking_code">({{ shipment.tracking_code }})</span>
          </a>
          <span *ngIf="shipment.enhanced_tracking_identifier">
            {{ shipment.enhanced_tracking_identifier }}
          </span>
          <span *ngIf="shipment.enhanced_tracking_identifier_type">
            ({{ shipment.enhanced_tracking_identifier_type.replaceAll('_', ' ') }})
          </span>
        </div>
      </div>

      <div class="col-md-3">
        <div class="shipment-actions">
          <a style="font-size: 16px !important;" matTooltip="View detail" class="btn btn-link text-secondary" (click)="showDetail(shipment.id)">
            <i class="fa fa-external-link" aria-hidden="true"></i>
          </a>
          <a style="font-size: 16px !important;" matTooltip="Edit Shipment" class="btn btn-link text-secondary"
             *ngIf="allowEdit && !shipment.enhanced_tracking_identifier"
             (click)="editShipment(shipment.id)">
            <i class="fa fa-edit" aria-hidden="true"></i>
          </a>
          <a style="font-size: 16px !important;" matTooltip="Delete Shipment"
             class="btn btn-link text-danger"
             *ngIf="allowEdit"
             (click)="removeShipment(shipment.id)">
            <i class="fa fa-trash"></i>
          </a>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #noShipmentsTracking>
  <span>No Shipments Tracking.</span>
</ng-template>
